const moment = require('moment')

export default {
  boardingPlaces: function () {
    let result = [
      {
        label: 'Escolha um local de embarque',
        value: null
      }
    ]

    if (this.trip) {
      result = result.concat(this.trip.boardingPlaces.map(boardingPlace => {
        let date = moment(boardingPlace.date).format('DD/MM/Y HH:mm')

        return {
          label: `${boardingPlace.boardingPlace ? boardingPlace.boardingPlace.title : boardingPlace.place} - ${date}`,
          value: boardingPlace.id
        }
      }))
    }

    return result
  }
}
